import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

/** Legacy routes redirect to calendar with inline personal event form. */
export default function PersonalEventFormPage(): null {
  const history = useHistory();
  const editMatch = useRouteMatch<{ id: string }>('/calendar/personal-events/edit/:id');

  useEffect(() => {
    if (editMatch?.params.id) {
      history.replace(`/calendar?personalEvent=edit&id=${editMatch.params.id}`);
      return;
    }
    history.replace('/calendar?personalEvent=create');
  }, [editMatch, history]);

  return null;
}
